import NotificationItemTemplate from '../../../ui-kit/components/templates/NotificationItemTemplate'
import Icon from '../../../ui-kit/components/atoms/Icon'

const InteractionNotification = ({className, icon, caption}) => {
  return (
    <NotificationItemTemplate
      className={className}
      graphic={<Icon className="icon" size="1.5rem" svg={icon} />}
      title="Matias Romero"
      caption={caption}
      time="Hace 22 minutos"
    />
  )
}

export default InteractionNotification
